<template>
  <page>
    <div slot="head" class="page-head-default">
      <img src="../../assets/imgs/back.png" alt="" @click="goRouter('/')">
      {{i18n.title}}
    </div>
    <div class="wallet-card-warp">
      <div v-for="(item, i) in items" :key="i">
        <slider-delete>
          <div class="wallet-card-row" @click="index = i">
            <img class="icon-card" src="../../assets/imgs/icon_creditcard.png" alt="">
            <div class="wallet-card-info">
              <div class="title">{{item.pCardnumber}}</div>
              <div>
                <span>{{item.pBrand}}</span>
              </div>
            </div>
            <div class="wallet-card-select">
              <img v-if="index === i" src="../../assets/imgs/success.png" alt="">
            </div>
          </div>
        </slider-delete>
      </div>
      <div class="wallet-card-btn" @click="goRouter('/confirm')">{{i18n.card_add}}</div>
    </div>
    <div class="wallet-card-foot" v-if="qrcode">
      <div class="btn" @click="onPreauth">{{i18n.submit}}</div>
    </div>
  </page>
</template>

<script>
import { mapState } from 'vuex'
import { PAYMENT_CARD, PAYMENT_PREAUTH } from '../../apis/payment'
import SliderDelete from '../../components/slider/delete'
export default {
  components: {
    SliderDelete
  },
  computed: {
    ...mapState(['user']),
    i18n () {
      return this.$t('mine')
    },
    i18nMsg () {
      return this.$t('msg')
    }
  },
  data () {
    return {
      qrcode: '',
      items: [],
      index: 0
    }
  },
  methods: {
    getCard () {
      this.$loading(true)
      this.$get(
        PAYMENT_CARD,
        {
          status: 1
        },
        resp => {
          this.$loading(false)
          this.items = resp.data
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    },
    goRouter (path) {
      this.$router.push(path)
    },
    onPreauth () {
      this.$loading(true)
      this.$post(
        `${PAYMENT_PREAUTH}/${this.qrcode}`,
        {
          cardId: this.items[this.index].pId
        },
        resp => {
          this.$loading(false)
          this.$router.push(`/result?tradeNo=${resp.data.outTradeNo}`)
        },
        error => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        }
      )
    }
  },
  created () {
    this.qrcode = this.$route.query.qrcode
    this.getCard()
  }
}
</script>

<style lang="less">
.wallet-card-warp {
  padding-bottom: 140px;
}
.wallet-card-row {
  display: flex;
  align-items: center;
  height: 150px;
  border-bottom: 1Px solid #dddddd;
  .icon-card {
    width: 100px;
    margin: 0 20px;
  }
  .title {
    font-size: 40px;
  }
  .wallet-card-info {
    flex: 1;
  }
  .wallet-card-select {
    width: 50px;
    height: 50px;
    border: 1Px solid #dddddd;
    border-radius: 50%;
    margin-right: 40px;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.wallet-card-btn {
  margin: 40px 60px;
  line-height: 100px;
  text-align: center;
  font-size: 32px;
  color: #909399;
  border: 1Px solid #dddddd;
  border-radius: 50px;
}
.wallet-card-foot {
  position: fixed;
  left: 40px;
  right: 40px;
  bottom: 40px;
}
</style>
